import React from 'react';
import './withSkeletonData.css';
import { getAdditionalProps } from '../utils';
var getSkeletonTdProps = getAdditionalProps('dm-table__cell dm-table__cell--body dm-table__cell--skeleton-data auto-table-cell-skeleton-data', function (state, rowInfo, column) {
  return {
    'data-label': column.label
  };
});
function getDummyRows(_ref) {
  var columns = _ref.columns,
    numberOfRows = _ref.numberOfRows;
  var rows = [];
  for (var index = 0; index < numberOfRows; index++) {
    rows.push({});
  }
  return rows;
}
export default function withSkeletonData(_ref2) {
  var emptyNumberOfRows = _ref2.emptyNumberOfRows;
  return function (TableComponent) {
    function SkeletonTable(props, ref) {
      var loadingProps = {};
      if (props.loading) {
        loadingProps = {
          dummyRows: !props.data.length && emptyNumberOfRows ? getDummyRows({
            columns: props.columns,
            numberOfRows: emptyNumberOfRows
          }) : null,
          className: "".concat(props.className || '', " auto-table-skeleton-data"),
          getTdProps: getSkeletonTdProps
        };
      }
      return /*#__PURE__*/React.createElement(TableComponent, Object.assign({
        ref: ref
      }, props, loadingProps));
    }
    return React.forwardRef(SkeletonTable);
  };
}